import type { AuthorizerSelectionConfig } from '@bayer-int/portletce-shared';
import { BWQuerySystem } from '@bayer-int/portletce-shared';

import {
    isLocal,
    localBackendUrl,
    remoteServersUrl,
    remoteServersUrlProd,
    noneAuthServersUrl,
} from './env';

const localBoot: Boot = {
    build: '',
    authConfig: {},
    servers: {
        backendServerHost: {
            url: `${localBackendUrl}`,
            description: '',
        },
        mockServer: {
            url: `${localBackendUrl}`,
            description:
                "Data mock server. mock services (e.g. 'dgen/deliveries?count=10') will be appended to this path. Replacement for tag :mockserver:",
        },
        portletSpec: {
            url: `${localBackendUrl}config/`,
            description: 'Server containing new portlet configurations (since aclibv2)',
        },
        vegaSpec: {
            url: `${localBackendUrl}config/`,
            description: 'Server containing new vega scripts (since aclibv2)',
        },
        namespaces: {
            url: `${localBackendUrl}namespace/`,
            description: 'Server containing portlet and spec namespaces',
        },
        masterData: {
            url: `${localBackendUrl}masterdata/`,
            description: 'Serves bayer specific masterdata',
        },
        bayerSapBWServer: {
            url: `${localBackendUrl}bw/`,
            description: 'Serves bayer SAP BW specific data',
        },
        bwQueryService: {
            [BWQuerySystem.H2D]: {
                url: 'http://localhost:8800/',
                description: 'Serves bayer BW Query specific data',
            },
            [BWQuerySystem.H2R]: {
                url: 'http://localhost:8800/',
                description: 'Serves bayer BW Query specific data',
            },
            [BWQuerySystem.H2S]: {
                url: 'http://localhost:8800/',
                description: 'Serves bayer BW Query specific data',
            },
            [BWQuerySystem.H2T]: {
                url: 'http://localhost:8800/',
                description: 'Serves bayer BW Query specific data',
            },
        },
        oauthServer: {
            url: '',
            description:
                'Url of the server that is used for oauth2 authorization (deployed resources only)',
        },
        graphApiServer: {
            url: 'https://graph.microsoft.com',
            description: 'Base url for the MS Graph API',
        },
        contentArea: {
            url: `${localBackendUrl}/content-area/`,
            description: 'Server containing content areas mail addresses',
        },
        themesServer: {
            // we use the remote service even for local dev. Use 'url()' syntax for themes if you need to use a local service.
            url: `${remoteServersUrl}/backend/themes/`,
            description: 'Server containing themes',
        },
        databricksServer: {
            url: `${remoteServersUrl}/backend/databricks-proxy/`,
            description: 'Databricks proxy',
        },
        microsoftGraph: {
            url: 'https://graph.microsoft.com/v1.0/search/query',
            description: 'Microsoft Graph API',
        },
        insightsNowServer: {
            url: 'https://dev-insightsnow.410855522248.cloud.bayer.com/api/vizagent',
            description: 'InsightsNow API',
        },
    },
};

const devBoot: Boot = {
    build: '',
    authConfig: {},
    servers: {
        backendServerHost: {
            url: `${remoteServersUrl}`,
            description: '',
        },
        mockServer: {
            url: `${remoteServersUrl}/backend/`,
            description:
                "Data mock server. mock services (e.g. 'dgen/deliveries?count=10') will be appended to this path. Replacement for tag :mockserver:",
        },
        portletSpec: {
            url: `${remoteServersUrl}/backend/config/`,
            description: 'Server containing new portlet configurations (since aclibv2)',
        },
        vegaSpec: {
            url: `${remoteServersUrl}/backend/config/`,
            description: 'Server containing new vega scripts (since aclibv2)',
        },
        namespaces: {
            url: `${remoteServersUrl}/backend/namespace/`,
            description: 'Server containing portlet and spec namespaces',
        },
        masterData: {
            url: `${remoteServersUrl}/backend/masterdata/`,
            description: 'Serves bayer specific masterdata',
        },
        bayerSapBWServer: {
            url: 'https://by-dch2r.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zbs_clib_parws/default.htm',
            description: 'Serves bayer SAP BW specific data',
        },
        bwQueryService: {
            [BWQuerySystem.H2D]: {
                url: 'https://by-dch2d.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',
                description: 'Serves bayer BW Query specific data for h2d system',
            },
            [BWQuerySystem.H2R]: {
                url: 'https://by-dch2r.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',
                description: 'Serves bayer BW Query specific data for h2r system',
            },
            [BWQuerySystem.H2S]: {
                url: 'https://by-dch2s.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',

                description: 'Serves bayer BW Query specific data for h2s system',
            },
            [BWQuerySystem.H2T]: {
                url: 'https://by-dch2t.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',

                description: 'Serves bayer BW Query specific data for h2t system',
            },
        },
        oauthServer: {
            url: `${remoteServersUrl}`,
            description:
                'Url of the server that is used for oauth2 authorization (deployed resources only)',
        },
        graphApiServer: {
            url: 'https://graph.microsoft.com',
            description: 'Base url for the MS Graph API',
        },
        contentArea: {
            url: `${remoteServersUrl}/backend/content-area/`,
            description: 'Server containing content areas mail addresses',
        },
        themesServer: {
            url: `${remoteServersUrl}/backend/themes/`,
            description: 'Server containing themes (dev)',
        },
        databricksServer: {
            url: `${remoteServersUrl}/backend/databricks-proxy/`,
            description: 'Databricks proxy',
        },
        microsoftGraph: {
            url: 'https://graph.microsoft.com/v1.0/search/query',
            description: 'Microsoft Graph API',
        },
        insightsNowServer: {
            url: 'https://dev-insightsnow.410855522248.cloud.bayer.com/api/vizagent',
            description: 'InsightsNow API',
        },
    },
};

export const prodBoot: Boot = {
    build: '',
    authConfig: {},
    servers: {
        backendServerHost: {
            url: `${remoteServersUrlProd}`,
            description: '',
        },
        mockServer: {
            url: `${remoteServersUrlProd}/backend/`,
            description:
                "Data mock server. mock services (e.g. 'dgen/deliveries?count=10') will be appended to this path. Replacement for tag :mockserver:",
        },
        portletSpec: {
            url: `${remoteServersUrlProd}/backend/config/`,
            description: 'Server containing new portlet configurations (since aclibv2)',
        },
        vegaSpec: {
            url: `${remoteServersUrlProd}/backend/config/`,
            description: 'Server containing new vega scripts (since aclibv2)',
        },
        namespaces: {
            url: `${remoteServersUrlProd}/backend/namespace/`,
            description: 'Server containing portlet and spec namespaces',
        },
        masterData: {
            url: `${remoteServersUrlProd}/backend/masterdata/`,
            description: 'Serves bayer specific masterdata',
        },
        bayerSapBWServer: {
            url: 'https://by-dch2r.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zbs_clib_parws/default.htm',
            description: 'Serves bayer SAP BW specific data',
        },
        bwQueryService: {
            [BWQuerySystem.H2D]: {
                url: 'https://by-dch2d.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',
                description: 'Serves bayer BW Query specific data for h2d system',
            },
            [BWQuerySystem.H2R]: {
                url: 'https://by-dch2r.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',
                description: 'Serves bayer BW Query specific data for h2r system',
            },
            [BWQuerySystem.H2S]: {
                url: 'https://by-dch2s.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',

                description: 'Serves bayer BW Query specific data for h2s system',
            },
            [BWQuerySystem.H2T]: {
                url: 'https://by-dch2t.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',

                description: 'Serves bayer BW Query specific data for h2t system',
            },
        },
        oauthServer: {
            url: `${remoteServersUrlProd}`,
            description:
                'Url of the server that is used for oauth2 authorization (deployed resources only)',
        },
        graphApiServer: {
            url: 'https://graph.microsoft.com',
            description: 'Base url for the MS Graph API',
        },
        contentArea: {
            url: `${remoteServersUrlProd}/backend/content-area/`,
            description: 'Server containing content areas mail addresses',
        },
        themesServer: {
            url: `${remoteServersUrlProd}/backend/themes/`,
            description: 'Server containing themes (prod)',
        },
        databricksServer: {
            url: `${remoteServersUrlProd}/backend/databricks-proxy/`,
            description: 'Databricks proxy',
        },
        microsoftGraph: {
            url: 'https://graph.microsoft.com/v1.0/search/query',
            description: 'Microsoft Graph API',
        },
        insightsNowServer: {
            url: 'https://prod-insightsnow.323150801305.cloud.bayer.com/api/vizagent',
            description: 'InsightsNow API',
        },
    },
};

export const noneAuthBoot: Boot = {
    build: '',
    authConfig: {},
    servers: {
        backendServerHost: {
            url: `${noneAuthServersUrl}`,
            description: '',
        },
        mockServer: {
            url: `${noneAuthServersUrl}/backend/`,
            description:
                "Data mock server. mock services (e.g. 'dgen/deliveries?count=10') will be appended to this path. Replacement for tag :mockserver:",
        },
        portletSpec: {
            url: `${noneAuthServersUrl}/backend/config/`,
            description: 'Server containing new portlet configurations (since aclibv2)',
        },
        vegaSpec: {
            url: `${noneAuthServersUrl}/backend/config/`,
            description: 'Server containing new vega scripts (since aclibv2)',
        },
        namespaces: {
            url: `${noneAuthServersUrl}/backend/namespace/`,
            description: 'Server containing portlet and spec namespaces',
        },
        masterData: {
            url: `${noneAuthServersUrl}/backend/masterdata/`,
            description: 'Serves bayer specific masterdata',
        },
        bayerSapBWServer: {
            url: 'https://by-dch2r.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zbs_clib_parws/default.htm',
            description: 'Serves bayer SAP BW specific data',
        },
        bwQueryService: {
            [BWQuerySystem.H2D]: {
                url: 'https://by-dch2d.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',
                description: 'Serves bayer BW Query specific data for h2d system',
            },
            [BWQuerySystem.H2R]: {
                url: 'https://by-dch2r.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',
                description: 'Serves bayer BW Query specific data for h2r system',
            },
            [BWQuerySystem.H2S]: {
                url: 'https://by-dch2s.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',

                description: 'Serves bayer BW Query specific data for h2s system',
            },
            [BWQuerySystem.H2T]: {
                url: 'https://by-dch2t.bayer-ag.com:8001/sap(bD1lbiZjPTIwMA==)/bc/bsp/sap/zdu_rest_qr_def/default.bsp',

                description: 'Serves bayer BW Query specific data for h2t system',
            },
        },
        oauthServer: {
            url: ``,
            description:
                'Url of the server that is used for oauth2 authorization (deployed resources only)',
        },
        graphApiServer: {
            url: 'https://graph.microsoft.com',
            description: 'Base url for the MS Graph API',
        },
        contentArea: {
            url: `${noneAuthServersUrl}/backend/content-area/`,
            description: 'Server containing content areas mail addresses',
        },
        themesServer: {
            url: `${noneAuthServersUrl}/themes/`,
            description: 'Server containing themes (noauth)',
        },
        databricksServer: {
            url: `${noneAuthServersUrl}/backend/databricks-proxy/`,
            description: 'Databricks proxy',
        },
        microsoftGraph: {
            url: 'https://graph.microsoft.com/v1.0/search/query',
            description: 'Microsoft Graph API',
        },
        insightsNowServer: {
            url: 'https://dev-insightsnow.410855522248.cloud.bayer.com/api/vizagent',
            description: 'InsightsNow API',
        },
    },
};

export const developmentBoot = isLocal ? localBoot : devBoot;

export const authServerUrl = isLocal
    ? 'http://localhost/authserver/bisso/whoami'
    : `${remoteServersUrl}/authserver/bisso/whoami`;

type ServerDefinition = {
    url: string;
    description: string;
};

export interface Boot {
    build: string;
    authConfig: Partial<AuthorizerSelectionConfig>;
    servers: {
        backendServerHost: ServerDefinition;
        mockServer: ServerDefinition;
        portletSpec: ServerDefinition;
        vegaSpec: ServerDefinition;
        masterData: ServerDefinition;
        bayerSapBWServer: ServerDefinition;
        bwQueryService: Record<BWQuerySystem, ServerDefinition>;
        oauthServer: ServerDefinition;
        graphApiServer: ServerDefinition;
        namespaces: ServerDefinition;
        contentArea: ServerDefinition;
        themesServer: ServerDefinition;
        databricksServer: ServerDefinition;
        microsoftGraph: ServerDefinition;
        insightsNowServer: ServerDefinition;
    };
}
